export function parseDate(date: string): Date {
  const match = date.match(/(\d{4})\-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
  if (match) {
    // build-in parsing is usually implementation-based and can lead to different results in different browsers
    // to prevent it we implement our own parsing for most used date formats
    return new Date(
      parseInt(match[1]),
      parseInt(match[2]) - 1,
      parseInt(match[3]),
      parseInt(match[4]),
      parseInt(match[5]),
      parseInt(match[6])
    );
  }
  return new Date(date);
}
